import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-final-form";
import createDecorator from "final-form-focus";
import moment from "moment-timezone";
import classnames from "classnames";

const focusOnError = createDecorator();
class Wizard extends React.Component {
  static Page = ({ children }) => children;

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: props.page || 0,
      values: props.initialValues || {},
    };
  }

  submit = null;

  getCurrentPage = () => {
    return this.state.page;
  };

  next = (values) =>
    this.setState((state) => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values,
    }));

  previous = () =>
    this.setState((state) => ({
      page: Math.max(state.page - 1, 0),
    }));

  goto = (page) => {
    const currentPage = this.state.page;
    if (currentPage === Number(page)) {
      return;
    }
    if (currentPage > Number(page)) {
      this.setState((state) => ({
        page: Math.max(page, 0),
      }));
    } else {
      const errors = this.validate(this.state.values);
      if (Object.values(errors).length === 0) {
        this.setState((state) => ({
          page: Math.max(page, 0),
        }));
      }
    }
  };

  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  validate = (values) => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];
    return activePage.props.validate ? activePage.props.validate(values) : {};
  };

  handleSubmit = (values) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      // There doesn't seem to be a way to set the date value as a string within the field itself.
      // Seems that the only way to handle date to string conversion is on submit.

      const submittedValues = {
        ...Object.fromEntries(Object.entries(values).filter(([_, v]) => !!v)),
      };

      Object.entries(submittedValues).forEach(function (value, index) {
        // Find Moment objects and convert to date string...
        if (
          value[1] &&
          typeof value[1] === "object" &&
          value[1]._isAMomentObject
        ) {
          submittedValues[value[0]] = moment(value[1])
            .tz("Australia/Sydney")
            .format("YYYY-MM-DD");
        }
      });
      return onSubmit(submittedValues);
    } else {
      this.next(values);
    }
  };

  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;

    return (
      <div>
        <div className="program__wrap donation-form__content">
          <div className="panel">
            <div className="tabbed_nav hide_at_bp_small">
              <ul className="tabbed_nav__inner" id="tabbed-donation-nav">
                <li className="tabbed_nav__item">
                  <a
                    className={classnames("tabbed_nav__link", {
                      js__selected: page === 0,
                    })}
                    onClick={(e) => {
                      this.goto(0);
                    }}
                    href="#donation"
                    title="Donation"
                  >
                    <span className="tabbed_nav__number">1</span>
                    <span className="tabbed_nav__title">
                      Financial Partnership
                    </span>
                  </a>
                </li>
                <li className="tabbed_nav__item">
                  <a
                    className={classnames("tabbed_nav__link", {
                      js__selected: page === 1,
                    })}
                    href="#details"
                    title="About Yourself"
                    onClick={(e) => {
                      this.goto(1);
                    }}
                  >
                    <span className="tabbed_nav__number">2</span>
                    <span className="tabbed_nav__title">About Yourself</span>
                  </a>
                </li>
                <li className="tabbed_nav__item">
                  <a
                    className={classnames("tabbed_nav__link", {
                      js__selected: page === 2,
                    })}
                    href="#payment"
                    title="How to pay"
                    onClick={(e) => {
                      this.goto(2);
                    }}
                  >
                    <span className="tabbed_nav__number">3</span>
                    <span className="tabbed_nav__title">How To Pay</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="form_section donation_panel">
              <Form
                initialValues={values}
                validate={this.validate}
                onSubmit={this.handleSubmit}
                decorators={[focusOnError]}
              >
                {({ handleSubmit, submitting, values: currentValues }) => {
                  this.submit = handleSubmit;
                  return (
                    <form
                      onSubmit={handleSubmit}
                      method="POST"
                      id="payment-form"
                    >
                      <div className="tabs-container donation-form__content-tab">
                        {activePage}
                      </div>
                      {page === 2 &&
                        currentValues.frequency !== "One-time Gift" &&
                        currentValues.payment_type !== "Direct Deposit" && (
                          <div className="panel__footnote">
                            <div>
                              <p>
                                Recurring payments will be processed on the date
                                selected for each period going forward.
                                Transactions on the 29th, 30th or 31st will be
                                moved to the 28th in the future. Recurring
                                fortnightly payments will be processed on the
                                same day, rather than date, every fortnight.
                              </p>
                              <p>
                                <i className="material-icons">lock</i> Please
                                note that AFES does not hold your bank account
                                details. These details are saved securely with
                                our banking partner Commonwealth Bank of
                                Australia.
                              </p>
                            </div>
                          </div>
                        )}
                      <div className="buttons">
                        {page > 0 && (
                          <button
                            type="button"
                            className="btn__solid--white save-button"
                            onClick={this.previous}
                          >
                            Previous
                          </button>
                        )}
                        {(page === 0 ||
                          (page === 1 && this.props.isAuthedOrGuest)) && (
                          <button
                            type="submit"
                            className="btn__solid  save-button"
                          >
                            Next
                          </button>
                        )}
                        {isLastPage && (
                          <button
                            type="submit"
                            className="btn__solid  save-button"
                            disabled={submitting}
                          >
                            Process My Support
                          </button>
                        )}
                      </div>
                    </form>
                  );
                }}
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Wizard;
